<template>
<v-container>
    <router-link tag="h1" class="mb-5" :to="{ name: 'questionares'}">Vragenlijsten</router-link>
    <v-card transition="scale-transition" class="mx-auto" v-if="$route.name == 'questionares'">
        <v-list two-line>
        <v-list-item-group
            active-class="primary--text">
            <template v-for="(item, index) in items">
            <v-list-item :key="item.title" :to="{ name: item.route }">
                <template v-slot:default="{ active, toggle }">
                <v-list-item-content>
                    <v-list-item-title class="uppercase" v-text="item.title"></v-list-item-title>
                    <v-list-item-subtitle class="text--primary" v-text="item.headline"></v-list-item-subtitle>
                    <v-list-item-subtitle class="wrap" v-text="item.subtitle"></v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                    <v-list-item-action-text v-text="item.action"></v-list-item-action-text>
                    <v-icon
                    v-if="!active"
                    color="grey lighten-1">
                    mdi-starBorder
                    </v-icon>

                    <v-icon
                    v-else
                    color="yellow">
                    mdi-star
                    </v-icon>
                </v-list-item-action>
                </template>
            </v-list-item>

            <v-divider
                v-if="index + 1 < items.length"
                :key="index"
            ></v-divider>
            </template>
        </v-list-item-group>
        </v-list>
    </v-card>
    <router-view transition="scale-transition" v-else></router-view>
    <p class="text-center mt-5" v-if="!$store.getters.isAuthenticated"><router-link tag="a" :to="{ name: 'login' }">Inloggen</router-link> of <router-link tag="a" :to="{ name: 'register' }">registeren</router-link>?</p>
</v-container>
</template>

<script>
  export default {
    data: () => ({
      items: [
        {
          action: '7 vragen',
          headline: 'ISI vragenlijst',
          title: 'Slaapevaluatie',
          subtitle: "Deze vragenlijst gaat over hoe u uw slaap ervaart. De ISI vragenlijst wordt gebruikt om de ernst van slapeloosheidsklachten te meten.",
          route: "isi"
        },
        // {
        //   action: '32 vragen',
        //   headline: 'HSDQ vragenlijst',
        //   title: 'Holland Sleep Disorders Questionnaire',
        //   subtitle: "De HSDQ vragenlijst is een breder instrument en omvat naast insomnie ook andere slaapstoornissen: parasomnie, circadiane ritmestoornissen, hypersomnolentie, restless legs syndrom en sleep breathing disorder.",
        //   route: "hsdq"
        // },
        {
          action: '19 vragen',
          headline: 'MEQ vragenlijst',
          title: 'Morningness-Eveningness Questionnaire',
          subtitle: "Ochtend- avondtype vragenlijst.",
          route: "meq"
        },
      ],
    }),
  }
</script>

<style scoped>
.uppercase {
    text-transform: uppercase;
}
.wrap {
  white-space: normal;
}
</style>